import StopCircleIcon from '@mui/icons-material/StopCircle';
import { Button } from 'react-admin';

interface IBulkTerminateButtonProps {
  handleOpenSuspendEmployeesModal: () => void;
}

function BulkTerminateButton({ handleOpenSuspendEmployeesModal }: IBulkTerminateButtonProps) {
  return (
    <Button
      sx={{
        color: '#d32f2f',
      }}
      label="resources.employees.terminate"
      onClick={handleOpenSuspendEmployeesModal}
    >
      <StopCircleIcon />
    </Button>
  );
}

export default BulkTerminateButton;
